/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState } from 'react';
import { useTheme } from '../../../providers/theme';

import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import {
  TimelineMercury,
  ITimelineMercuryProps,
} from '@vlinder-web/timeline-mercury-widget-react';

import { HeroSection, Header, TimelineDetailModal } from '../components';
import { useSMUpdateBankDetail, useSMmyPayoutPage } from '../machines';
import { vappContainer } from '@/application';
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';
import { NomineeKYCService } from '@pages/NomineeKYCPage/services';
import { TweetyModal } from '@vlinder-web/tweety-modal-widget-react';
import { toast } from 'react-hot-toast';

const getSrv = () => {
  return vappContainer.get<NomineeKYCService>(NomineeKYCService.displayName);
};

export const ContainerComm = (props: any) => {
  const [showModal, setShowModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [cardModal, setCardModal] = useState(false);
  const [cardId, setCardId] = useState('');

  const staticPageContentConfig = getSrv().agent.getStaticContentSync();
  const srv = getSrv();

  const {
    updateBankDetailMachine,
    updateBankDetailSend,
    updateBankDetailState,
  } = useSMUpdateBankDetail({});

  const theme = useTheme();

  const { myPayoutPageMachine, myPayoutPageSend, myPayoutPageState } =
    useSMmyPayoutPage({});

  const onButtonPress = (key: string) => {
    // if (!showModal) {
    //   setShowModal(true);
    // }
    if (key === 'edit') {
      if (!showModal) {
        setShowModal(true);
      }
    }
  };

  const onModalClose = () => {
    if (showModal) {
      setShowModal(false);
    }
    if (updateModal) {
      setUpdateModal(false);
    }
  };

  const onRefresh = () => {
    myPayoutPageSend('TRIGGER_REFRESH', {});
  };
  const onUpdateProfile = (data: any) => {
    // console.log(`data in form submit`, data);
    if (showModal) {
      setShowModal(false);
    }
    if (data?.accountNo === data?.cnfAccountNumber) {
      updateBankDetailSend('START', {
        payload: {
          ...data,
          chequeLeaf: {
            doc: data?.chequeLeaf[0]?.base64,
            fileType: data?.chequeLeaf[0]?.type,
            type: 'CHEQUE_LEAF',
            name: data?.chequeLeaf[0]?.name,
          },
        },
      });
    } else {
      toast.error('Confirm Account Number does not match Account Number');
    }
  };

  const onCardClick = (id: string) => {
    console.log(`card clicked`, id);
    let _cardDetail = srv.agent?.getFormatTimelineDetailSync({
      ...myPayoutPageState?.event?.data?.value?.txList,
      cardId: id,
    });
    console.log('card detail', _cardDetail);
    if (
      Array.isArray(_cardDetail?.data?.data) &&
      _cardDetail?.data?.data?.length > 0
    ) {
      if (!cardModal) {
        setCardModal(true);
      }
      setCardId(id);
    }
  };

  const onCardClose = (id: string) => {
    if (cardModal) {
      setCardModal(!cardModal);
    }
  };

  const _renderModal = () => {
    if (showModal) {
      return (
        <TweetyModal
          show={true}
          size={'md'}
          scrollable={false}
          backdrop={'static'}
          submitButtonTitle={'Update'}
          onSubmit={onUpdateProfile}
          onHide={() => setShowModal(false)}
          title={'Update Bank Details'}
          tweetyWidgetProps={{
            fields: staticPageContentConfig?.editProfile?.FIELDS,
            layout: staticPageContentConfig?.editProfile?.layout,
            validatorConfig:
              staticPageContentConfig?.editProfile?.validatorConfig,
            initialData: myPayoutPageState?.event?.data?.value?.initialData,
          }}
        />
      );
    }
    if (cardModal) {
      let _temp = srv?.agent?.getFormatTimelineDetailSync({
        ...myPayoutPageState?.event?.data?.value?.txList,
        cardId,
      });
      console.log(`_temp data`, _temp);
      return (
        <TimelineDetailModal
          showModal={cardModal}
          modalTitle={_temp?.title}
          data={_temp?.data}
          onDeny={onCardClose}
        />
      );
    }
  };

  const _renderPage = () => {
    if (updateBankDetailState?.matches('UPDATE_BANK_DETAIL')) {
      return (
        <StateOSD
          {...(staticPageContentConfig?.loading?.updateProfile || {})}
        />
      );
    }
    if (myPayoutPageState?.matches('RENDER_PAGE')) {
      console.log(`timeline data`, myPayoutPageState?.event?.data?.value);
      return (
        <>
          <HeroSection
            {...(staticPageContentConfig?.bankConfig || {})}
            {...(myPayoutPageState?.event?.data?.value || {})}
            onHeroButtonClick={onButtonPress}
          />
          {myPayoutPageState?.event?.data?.value?.timelineData?.length > 0 ? (
            <TimelineMercury
              items={myPayoutPageState?.event?.data?.value?.timelineData ?? []}
              onItemClick={onCardClick}
            />
          ) : null}
        </>
      );
    }
    if (myPayoutPageState?.matches('GET_PAGE_CONTENT')) {
      return (
        <StateOSD
          {...(staticPageContentConfig?.loading?.loadingProfile || {})}
        />
      );
    }
    return (
      <>
        <HeroSection
          {...(staticPageContentConfig?.bankConfig || {})}
          {...(myPayoutPageState?.event?.data?.value || {})}
          onHeroButtonClick={onButtonPress}
        />
      </>
    );
  };
  const _renderErrorModals = () => {
    if (updateBankDetailState?.matches('UPDATE_BANK_DETAIL_FAILED')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.updateProfile || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    return null;
  };
  const _renderNotification = () => {
    if (updateBankDetailState?.matches('UPDATE_BANK_DETAIL_SUCCESS')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.notifications?.updateProfileSuccess ||
            {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    return null;
  };

  const _renderHeader = () => {
    if (staticPageContentConfig?.header) {
      return (
        <>
          <Header {...(staticPageContentConfig?.header || {})} />
        </>
      );
    }
    return null;
  };

  return (
    <>
      {_renderHeader()}
      {_renderPage()}
      {_renderModal()}
      {_renderErrorModals()}
      {_renderNotification()}
    </>
  );
};
